var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', {
    attrs: {
      "renderBackAndForthFooter": false,
      "isProgressDone": true,
      "showFooter": false
    }
  }, [_c('v-container', {
    staticClass: "padded"
  }, [_c('v-row', [_c('v-card', {
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "display-1 text--primary"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })])], 1)], 1), _c('v-row', {
    attrs: {
      "v-if": _vm.isNotification
    }
  }, _vm._l(_vm.notifications, function (notification, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "prominent": "",
        "type": notification.type,
        "width": "100%",
        "elevation": "1"
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push(notification.location);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(notification.message)) + " ")]);
  }), 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": _vm.newCar
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-new-vehicle-1.jpeg"
    }
  }, [_c('v-card-title', [_vm._v("Neues Fahrzeug anlegen")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": _vm.vehicleOvervie
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": "https://static.mmmint.ai/wirkaufendeinethg/parkplatz-1.jpeg"
    }
  }, [_c('v-card-title', [_vm._v("Zur Fahrzeugübersicht")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": _vm.toProfile
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-contact-data-1.jpeg"
    }
  }, [_c('v-card-title', [_vm._v("Kontaktdaten verwalten")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": _vm.toBillings
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-contact-cash-1.jpeg"
    }
  }, [_c('v-card-title', [_vm._v("Rechnungsübersicht")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6"
    }
  }, [_vm.isInviteFriendsEnabled ? _c('v-card', {
    on: {
      "click": _vm.inviteFriends
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "height": "200px",
      "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
      "src": "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-invite-friends-1.jpeg"
    }
  }, [_c('v-card-title', [_vm._v("Freunde einladen")])], 1)], 1) : _vm._e()], 1)], 1), _c('v-btn', {
    attrs: {
      "elevation": "6",
      "color": _vm.partnerColor,
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.newCar
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" mdi-plus ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }